export const DeliveringIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="24" r="24" fill="currentColor" fillOpacity="0.1" />
    <path
      d="M31 28H33C33.5304 28 34.0391 27.7893 34.4142 27.4142C34.7893 27.0391 35 26.5304 35 26V22.67C34.9998 22.4117 34.9482 22.156 34.848 21.918L32.848 17.218C32.7208 16.9177 32.5111 16.6608 32.2429 16.4762C31.9747 16.2917 31.6594 16.187 31.333 16.174L29 16.083V21C29 21.5304 28.7893 22.0391 28.4142 22.4142C28.0391 22.7893 27.5304 23 27 23H25"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 32C21.6569 32 23 30.6569 23 29C23 27.3431 21.6569 26 20 26C18.3431 26 17 27.3431 17 29C17 30.6569 18.3431 32 20 32Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M30 32C31.6569 32 33 30.6569 33 29C33 27.3431 31.6569 26 30 26C28.3431 26 27 27.3431 27 29C27 30.6569 28.3431 32 30 32Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M23 29H27M17 29H13V17C13 16.4696 13.2107 15.9609 13.5858 15.5858C13.9609 15.2107 14.4696 15 15 15H27C27.5304 15 28.0391 15.2107 28.4142 15.5858C28.7893 15.9609 29 16.4696 29 17V29"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
